/*
 *  Shows a dialog when the upcoming session is a selectable one (and the user hasn't selected it)
 */

import moment from 'moment';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import {
    isSessionAttendanceOptional,
    isUpcomingSession,
} from '../../../data/filters/scheduleFilters';
import { useUpdateWhenScheduleAdvances } from '../../../data/hooks/datetimeHooks';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useI18n } from '../../../data/hooks/i18nHooks';
import { useScheduleSessionRoute } from '../../../data/hooks/routingHooks';
import { useSelectedSessions } from '../../../data/hooks/schedule/useSelectedSessions';
import { useUserPotentialSchedule } from '../../../data/hooks/schedule/useUserPotentialSchedule';
import { useSessionsInProgress } from '../../../data/hooks/schedule/useSessionsInProgress';
import Link from '../../elements/Link';
import SidePanelDialog from '../common/SidePanelDialog/SidePanelDialog';
import {
    SCHEDULE_SESSION_DISPLAY_TYPE_ONLINE,
    SCHEDULE_SESSION_DISPLAY_TYPE_ROUND,
} from 'common-data-handling';

const BEFORE_MINUTES = 5,
    CURRENT_SESSION_NEAR_END = 10;

const SelectProgramDialog = () => {
    const { eventId } = useParams(),
        event = useEvent(eventId),
        i18n = useI18n(),
        [closed, setClosed] = useState([]),
        currentSession = useSessionsInProgress(eventId).filter(
            (session) =>
                session.display_type != SCHEDULE_SESSION_DISPLAY_TYPE_ROUND
        )[0],
        selectedSessions = useSelectedSessions(eventId),
        currentRound = useSessionsInProgress(eventId, {
            filter: (session) =>
                session.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_ONLINE &&
                session.is_selectable &&
                !session.is_selected &&
                !selectedSessions.find(
                    (selectedSession) =>
                        selectedSession.round_id == session.round_id
                ),
        })[0],
        upcomingSelectableSession = useUserPotentialSchedule(eventId, {
            filter: (s) =>
                event.settings.workshop_selection &&
                !closed.includes(s.id) &&
                isUpcomingSession(s, 5, 5, 'minutes') &&
                isSessionAttendanceOptional(s),
        })[0],
        upcomingHref = useScheduleSessionRoute(
            eventId,
            upcomingSelectableSession?.id
        );

    // console.log('SELECT PROGRAM DIALOG', moment().format('LTS'), !!upcomingSelectableSession);
    useUpdateWhenScheduleAdvances(eventId, -BEFORE_MINUTES);

    function handleClose() {
        setClosed([...closed, upcomingSelectableSession.id]);
    }

    function handleScheduleOpened() {
        handleClose();
        app.store.dispatch(app.actions.ui.sidePanel.maximize(false));
    }

    if (upcomingSelectableSession) {
        if (
            !currentSession ||
            moment().diff(currentSession.end_utc, 'minutes') >
                -CURRENT_SESSION_NEAR_END ||
            (currentRound &&
                moment().diff(currentRound.start_utc, 'minutes') <
                    BEFORE_MINUTES)
        ) {
            return (
                <SidePanelDialog
                    className="SelectProgramDialog"
                    onClose={handleClose}
                >
                    <p className={'text'}>{i18n['label.tip.select-session']}</p>
                    <br />
                    <Link
                        className={'center-text'}
                        style={{
                            ...event._local.styles.button,
                            padding: 10,
                            margin: '0 20px',
                            fontWeight: 'bold',
                            minWidth: '180px',
                            borderRadius: '4px',
                        }}
                        href={upcomingHref}
                        onClick={handleScheduleOpened}
                    >
                        {i18n['label.tap-to-select-workshop']}
                    </Link>
                </SidePanelDialog>
            );
        }
    }
    return null;
};

export default SelectProgramDialog;
